import { useEffect } from 'react';
import { useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router';
import { ColumnView } from '../../components/ColumnView';
import { Container } from '../../components/Container';

export default function View() {
  const navigate = useNavigate();
  const { signOut } = useClerk();

  async function logout() {
    await signOut();
    navigate('/');
  }

  useEffect(() => {
    logout();
  }, []);

  return (
    <ColumnView>
      <div className="flex flex-col items-center justify-center mt-16">
        <Container>
          <h1 className="text-xl font-bold m-4">Logging out...</h1>
        </Container>
      </div>
    </ColumnView>
  );
}
